import React, { useContext } from 'react';
import { Form, Typography } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import {
  ApplicationUIContext,
  DragDropContext,
  DragAndDropList,
  Subcontent,
} from '@yuhuinc/ui-library';
import { SpaceFullWidth } from '../../common/Styles';

const { Title, Text } = Typography;

const DUMMY_DATA_2 = [
  { label: 'Standard addendum #1' },
  { label: 'Standard addendum #2' },
  { label: 'Parking space' },
  { label: 'Bike rack' },
];

const translate = (key) =>
  getTranslatedString(`landlordPortal.applicationManagement.leaseOverview.${key}`);

const LeaseDocuments = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const form = Form.useFormInstance();

  const onDragEnd = (result) => console.log(result);

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Title level={isMobile ? 4 : 5}>{translate('leaseDetails.leaseDocuments')}</Title>
      <SpaceFullWidth direction="vertical" size="middle">
        <Text strong>{translate('leaseDetails.leaseDocuments.baseTemplate')}</Text>
        <Subcontent
          label="Standard lease template"
          collapsed
          hideEdit
          hideDelete
          isMobile={isMobile}
        />
        <Text strong>{translate('leaseDetails.leaseDocuments.addenda')}</Text>
        <DragAndDropList
          items={DUMMY_DATA_2}
          listId="ADDENDA_LEASE_DOCUMENTS"
          renderItemLabel={(item) => item.label}
          hideEdit
          hideDelete
          isMobile={isMobile}
        />
      </SpaceFullWidth>
    </DragDropContext>
  );
};

export default LeaseDocuments;
